/**
 * A product's picture: the cut-out bottle the shop's front page draws on its
 * card (`shop_details.shop.card_image`), on a see-through background so it
 * sits on whatever background its box has.
 *
 * Not the catalog's top-level `shop_card_image`: on dev most newer products
 * point it at RxPros storage, which answers 403, and on prod those products
 * have none. A product the shop draws no card for (a checkout fee) gets null,
 * so each screen shows its own placeholder rather than another product's bottle.
 */
export const shopCardImage = (product) => product?.shop_details?.shop?.card_image || null;
